import { withSvgIcon } from './withSvgIcon';

export const StepError = withSvgIcon(
  <>
    <circle cx="16" cy="16" r="16" fill="#EEA941" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7644 9C14.5103 9 14.3104 9.21719 14.3315 9.47043L14.9831 17.2889C15.0018 17.514 15.19 17.6872 15.4159 17.6872H16.6146C16.8405 17.6872 17.0287 17.514 17.0474 17.2889L17.699 9.47043C17.7201 9.21719 17.5202 9 17.2661 9H14.7644ZM16 23C16.9595 23 17.7374 22.2221 17.7374 21.2626C17.7374 20.3031 16.9595 19.5253 16 19.5253C15.0405 19.5253 14.2626 20.3031 14.2626 21.2626C14.2626 22.2221 15.0405 23 16 23Z"
      fill="white"
    />
  </>,
  { viewBox: '0 0 32 32' },
);
